<template>
	<div v-if="item?.price_custom > 0" class="cd-price" :class="{'fixed-bar': mode == 'fixedBar', 'uau-badge': item.selected_price && item.selected_price == 'uau', 'inactive': item.price_custom_prices_cart && item.price_custom_prices_cart_expire}">
		<template v-if="item.type == 'advanced'">
			<div v-if="item.primary_product_data && !advancedItem" class="cd-current-price">{{ formatCurrency(item.basic_price_custom) }}</div>
			<template v-if="item.type_config">
				<div v-for="(config, key) in item.type_config" :key="key">
					<template v-if="config.price_custom > 0">
						<template v-if="advancedItem && advancedItem == key">
							<template
								v-if="config?.selected_price == 'recommended' && (config.discount_percent_custom > 0 || config.price_custom < config.basic_price_custom) && ((!config.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && config.loyalty_price_custom && config.price_custom < config.loyalty_price_custom))">
								<div class="cd-old-price special">
									<span>{{ formatCurrency(item.basic_price_custom) }}</span>
									<span class="cd-old-price-icon">
										<span class="cd-old-price-tooltip">
											<span class="cd-old-price-tooltip-close"></span>
											<BaseCmsLabel code="permanently_low_price_tooltip" tag="span" />
										</span>
									</span>
								</div>
								<div v-if="mode != 'fixedBar'" class="cd-price-label red"><BaseCmsLabel code="permanently_low_price_tooltip" tag="span" /></div>
								<div class="cd-current-price red">{{ formatCurrency(config.price_custom) }}</div>
							</template>
							<template v-if="config.selected_price == 'promotion2' && ((!config.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && config.loyalty_price_custom && config.price_custom < config.loyalty_price_custom))">
								<div class="cd-current-price">
									<span class="value">{{ formatCurrency(config.price_custom) }}</span>
									<div v-if="mode != 'fixedBar' && item.price_custom < item.basic_price_custom" class="cd-badge-discount-info cd-badge-promotion2 yellow">
										<BaseCmsLabel code="prihranek_promotion" />:&nbsp; <strong>{{ formatCurrency(config.basic_price_custom - config.price_custom) }}</strong>
									</div>
								</div>
							</template>
							<template
								v-else-if="(config.discount_percent_custom > 0 || config.price_custom < config.basic_price_custom) && ((!config.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && config.loyalty_price_custom && config.price_custom < config.loyalty_price_custom))">
								<div class="cd-old-price line-through">{{ formatCurrency(config.basic_price_custom) }}</div>
								<div class="cd-current-price red">
									<span class="value">{{ formatCurrency(config.price_custom) }}</span>
									<div v-if="mode != 'fixedBar' && (config.discount_percent_custom > 0 || config.price_custom < config.basic_price_custom)" class="cd-badge-discount-info">
										<BaseCmsLabel code="prihranek" />&nbsp; <strong>{{ formatCurrency(config.basic_price_custom - config.price_custom) }}</strong>
									</div>
								</div>
							</template>
							<template v-else-if="isLoyalty == true && config.loyalty_price_custom && config.loyalty_price_custom < config.basic_price_custom">
								<div class="cd-old-price line-through">
									<template v-if="config.selected_price == 'recommended' && (config.discount_percent_custom > 0 || config.price_custom < config.basic_price_custom)">{{ formatCurrency(config.price_custom) }}</template>
									<template v-else>{{ formatCurrency(config.basic_price_custom) }}</template>
								</div>
								<div v-if="mode != 'fixedBar'" class="cd-price-label"><BaseCmsLabel code="klubska_cena" /></div>
								<div class="cd-current-price blue">
									<span class="value">{{ formatCurrency(config.loyalty_price_custom) }}</span>
									<div v-if="mode != 'fixedBar' && (config.loyalty_price_custom < config.basic_price_custom)" class="cd-badge-discount-info blue">
										<BaseCmsLabel code="klubski_prihranek" />
										<strong v-if="config?.selected_price == 'recommended' && (config.discount_percent_custom > 0 || config.price_custom < config.basic_price_custom)">{{ formatCurrency(config.price_custom - config.loyalty_price_custom ) }}</strong>
										<strong v-else>{{ formatCurrency(config.basic_price_custom - config.loyalty_price_custom) }}</strong>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="cd-current-price">{{ formatCurrency(config.price_custom) }}</div>
							</template>
							<CatalogWidgetDetailInstallment v-if="mode != 'fixedBar'" :item="config" />
						</template>
					</template>
					<template v-else>
						<span class="cd-price-zero" v-html="labels.get('price_zero')"></span>
					</template>
				</div>
			</template>
		</template>
		<template v-else>
			<template
				v-if="item?.selected_price == 'recommended' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom) && ((!item.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))">
				<div class="cd-old-price special">
					<span>{{ formatCurrency(item.basic_price_custom) }}</span>
					<span class="cd-old-price-icon">
						<span class="cd-old-price-tooltip">
							<span class="cd-old-price-tooltip-close"></span>
							<BaseCmsLabel code="permanently_low_price_tooltip" tag="span" />
						</span>
					</span>
				</div>
				<div v-if="mode != 'fixedBar'" class="cd-price-label red"><BaseCmsLabel code="permanently_low_price_tooltip" tag="span" /></div>
				<div class="cd-current-price red">{{ formatCurrency(item.price_custom) }}</div>
			</template>
			<template v-if="item.selected_price == 'promotion2' && ((!item.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))">
				<div class="cd-current-price">
					<span class="value">{{ formatCurrency(item.price_custom) }}</span>
					<div v-if="mode != 'fixedBar' && item.price_custom < item.basic_price_custom" class="cd-badge-discount-info cd-badge-promotion2 yellow">
						<BaseCmsLabel code="prihranek_promotion" />:&nbsp; <strong>{{ formatCurrency(item.basic_price_custom - item.price_custom) }}</strong>
					</div>
				</div>
			</template>
			<template v-else-if="(item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom) && ((!item.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))">
				<div class="cd-old-price line-through">{{ formatCurrency(item.basic_price_custom) }}</div>
				<div class="cd-current-price red">
					<span class="value">{{ formatCurrency(item.price_custom) }}</span>
					<div v-if="mode != 'fixedBar' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom)" class="cd-badge-discount-info">
						<BaseCmsLabel code="prihranek" />&nbsp; <strong>{{ formatCurrency(item.basic_price_custom - item.price_custom) }}</strong>
					</div>
				</div>
			</template>
			<template v-else-if="isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.basic_price_custom">
				<div class="cd-old-price line-through">
					<template v-if="item.selected_price == 'recommended' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom)">{{ formatCurrency(item.price_custom) }}</template>
					<template v-else>{{ formatCurrency(item.basic_price_custom) }}</template>
				</div>
				<div v-if="mode != 'fixedBar'" class="cd-price-label"><BaseCmsLabel code="klubska_cena" /></div>
				<div class="cd-current-price blue">
					<span class="value">{{ formatCurrency(item.loyalty_price_custom) }}</span>
					<div v-if="mode != 'fixedBar' && (item.loyalty_price_custom < item.basic_price_custom)" class="cd-badge-discount-info blue">
						<BaseCmsLabel code="klubski_prihranek" />
						<strong v-if="config?.selected_price == 'recommended' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom)">{{ formatCurrency(item.price_custom - item.loyalty_price_custom ) }}</strong>
						<strong v-else>{{ formatCurrency(item.basic_price_custom - item.loyalty_price_custom) }}</strong>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="cd-current-price">{{ formatCurrency(item.price_custom) }}</div>
			</template>
			<CatalogWidgetDetailInstallment v-if="mode != 'fixedBar'" :item="item" />
		</template>

		<!-- Special price -->
		<template v-if="mode == 'fixedBar' && item.is_available && item.price_custom_prices_cart && item.price_custom_prices_cart_expire">
			<BaseCmsLabel code="configured_price" tag="span" class="cd-conf-current-price-label" />
			<span class="cd-current-price special red"><BaseUtilsFormatCurrency :price="item.price_custom_prices_cart" /></span>
		</template>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const auth = useAuth();
	const props = defineProps(['item', 'mode', 'advancedItem']);
	const {formatDate} = useText();
	const {formatCurrency} = useCurrency();
	const {emit} = useEventBus();

	//loyalty
	const isLoyalty = computed(() => {
		const user = auth.getUser();
		if(user?.loyalty_code) {
			return true;
		} else {
			return false;
		}
	});
</script>

<style lang="less" scoped>
	.cd-price{
		flex-grow: 1; position: relative;
		&.uau-badge{
			.cd-current-price:not(.blue), .cd-installment-price span{color: #f57855;}
		}
		&.inactive{
			.cd-old-price, .cd-current-price, .cd-installment-price, .cd-installments-calculate-label{filter: grayscale(100%); opacity: 0.8;}
		}
	}
	.cd-old-price{
		display: block; margin: 0 0 1px; font-size: 15px; line-height: 1.5;
		&.special{display: flex; align-items: center; margin-bottom: 5px;}
	}
	.cd-old-price-icon{
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 15px; height: 15px; margin-left: 6px; position: relative;
		&:before{.icon-info(); font: 15px/15px @fonti; color: @textColor; .transition(color);}
		&.active{
			&:before{color: @blue;}
			.cd-old-price-tooltip{visibility: visible; opacity: 1; z-index: 11;}
		}
	}
	.cd-old-price-tooltip{
		width: 300px; background: @white; padding: 15px 25px; font-size: 13px; line-height: 1.5; color: @textColor; position: absolute; left: -66px; top: calc(~"100% - -10px"); box-shadow: 0 0 20px 0 rgba(51,51,51,0.18); z-index: -1; visibility: hidden; opacity: 0; .transition(opacity);
		&:before{.pseudo(8px,8px); background: @white; left: 69px; top: -3px; .rotate(45deg);}
		&:after{.pseudo(auto,10px); left: 0; right: 0; top: -10px;}
		a{
			color: @blue; text-decoration: underline;
			&:hover{color: @blue; text-decoration: none;}
		}
		p{padding-bottom: 0;}

		@media (max-width: @m){padding: 15px 20px; font-size: 14px;}
	}
	.cd-old-price-tooltip-close{
		display: none;

		@media (max-width: @t){
			display: flex; align-items: center; justify-content: center; width: 34px; height: 34px; background: @blue; border: 2px solid @white; border-radius: 100%; position: absolute; top: -16px; right: -16px; box-shadow: 0 0 20px 0 rgba(51,51,51,0.18); z-index: 1;
			&:before{.icon-x(); font: 14px/14px @fonti; color: @white;}
		}
	}
	.cd-price-label{
		display: block; font-size: 13px; line-height: 1.4; color: @blue; font-weight: 600; margin: 5px 0 1px;
		&.red{color: @red;}
	}
	.cd-current-price{
		display: flex; align-items: center; font-size: 28px; line-height: 1.1; font-weight: 600; flex-shrink: 0;
		&.blue{color: @blue;}
		&.hidden{display: none;}
		.value{flex-shrink: 0; flex-grow: 0;}
		@media (max-width: @t){font-size: 26px;}
		@media (max-width: @m){flex-direction: column; align-items: flex-start;}
	}
	.cd-badge-discount-info{
		display: flex; align-items: center; flex-wrap: wrap; margin-left: 15px; padding: 3px 12px; background: @red; font-size: 14px; line-height: 1.3; color: @white; position: relative;
		&.blue{
			background: @blue;
			&:before{background: @blue;}
		}
		&.yellow{
			background: #CDD700; color: @textColor;
			&:before{background: #CDD700;}
		}
		strong{font-size: 16px;}
		&:before{.pseudo(6px,6px); background: @red; left: -2px; top: 50%; transform: translateY(-50%) rotate(45deg);}

		@media (max-width: @m){
			margin: 7px 0 0; padding: 4px 10px;
			&:before{content: none;}
		}
	}
	.cd-price-zero{
		font-size: 22px;

		@media (max-width: @t){font-size: 18px;}
	}

	.fixed-bar{
		flex-shrink: 0; text-align: right; order: 3;
		&.inactive{
			.cd-old-price, .cd-current-price, .cd-installment-price, .cd-installments-calculate-label{display: none;}
			.cd-current-price.special{display: block; filter: none; opacity: 1;}
		}
		.cd-conf-price{text-align: right; order: 3;}
		.cd-conf-current-price-label{display: block; font-size: 13px; line-height: 1.2; font-weight: 600; color: @red;}
		.cd-old-price{font-size: 14px; line-height: 19px; margin: 0 0 2px;}
		.cd-current-price{display: block; font-size: 20px;}
		.cd-price-zero{font-size: 14px;}

		@media (max-width: @t){
			.add-to-cart-disabled:after{content: none;}
		}
		@media (max-width: @m){
			text-align: left; flex-grow: unset; width: 50%; padding-right: 20px;
			.cd-conf-price{text-align: left;}
		}
	}
</style>
